<div class="page-content">
    <%- refHtml %>
    <div class="container-fluid p-6"
         style="background-color: white; color: #1c1c1c">
        <p class="text-center">
            LET'S BUILD SOMETHING GREAT TOGETHER
        </p>
        <h2 class="text-center">
            WIR SIND NUR<br />EINE NACHRICHT ENTFERNT!
        </h2>
        <p class="text-center mt-4">
            <button data-id="ref-button-contact"
                    class="btn btn-ref-contact">KONTAKT</button>
        </p>
    </div>
    <footer class="footer p-6" style="padding-top: 8rem!important; padding-bottom: 4rem!important; background-color: #1c1c1c">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-8">
                    <img src="/assets/images/ahd-icon.svg" style="width: 64px;" />
                    <p style="margin-top: 12px">
                        aheadware Gmbh · Marie-Curie-Str. 12 · 21337 Lüneburg | +49(0)-4131-217 40 60 | hello@aheadware.com
                    </p>
                    <p>
                        <a href="/legal/impressum">IMPRESSUM</a> | <a href="/legal/agb">AGB</a> | <a href="/legal/disclaimer">HAFTUNGSAUSSCHLUSS</a> | <a href="/legal/datenschutz">DATENSCHUTZERKLÄRUNG</a>
                    </p>
                </div>
                <div class="col-xl-4 align-self-end">
                    <p style="text-align: right">
                        Engineering with <i class="fa-regular fa-computer-classic"></i> and <i class="fa-solid fa-binary"></i> since 1337
                    </p>
                </div>
            </div>
        </div>
    </footer>
</div>
